// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ukp1X","requiredAsterisk":"Info_requiredAsterisk__mwEgw"};